var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a, _b, _c, _d;
/* miscellaneous & multi-platform helpers go here */
import { APP_VERSION, EventVendorMap, FAVORITES_TYPE_PERSONALITY, FoxProfileEvents, LOGGED_IN, LOGGED_OUT, MAX_REFERRER_LENGTH, NATION, OPTIMIZELY_COLLECTION_VIEWED, OPTIMIZELY_COLLECTION_VIEWED_SESSION_STORAGE, PageEvents, PageNames, PAGE_PROPS_STORAGE, SECOND_SCREEN_ANONYMOUS_ID, SegmentPlayerStates, SegmentVideoEventStrings, SESSION_STORAGE_REFERRER_TRACKING, TrackEvents, Vendors, } from "./Enums";
import { callPlayerEvent as callSegmentPlayerEvent, getLastAnonymousProfileId, getLastKnownProfileId, getPageStartSource as getSegmentPageStartSource, getPageReferrerDataFromStorage, handleSegmentAnalytics, } from "./SegmentHelper";
import { getAccountEvents as getTealiumAccountEvents, getPreviewPassEvents as getTealiumPreviewPassEvents, handleTealiumAnalytics, } from "./TealiumHelper";
import createFunctionContext from "./utils/CreateFunctionContext";
var FP_SIGNED_OUT = FoxProfileEvents.FP_SIGNED_OUT, FP_SIGN_IN_ATTEMPTED = FoxProfileEvents.FP_SIGN_IN_ATTEMPTED, FP_SIGN_IN_COMPLETED = FoxProfileEvents.FP_SIGN_IN_COMPLETED, FP_SIGN_OUT_ATTEMPTED = FoxProfileEvents.FP_SIGN_OUT_ATTEMPTED, FP_SIGN_UP_ATTEMPTED = FoxProfileEvents.FP_SIGN_UP_ATTEMPTED, FP_SIGN_UP_COMPLETED = FoxProfileEvents.FP_SIGN_UP_COMPLETED;
var CHANGE_PASSWORD_PAGE_VIEW = PageEvents.CHANGE_PASSWORD_PAGE_VIEW, KNOWN_PROFILE_PAGE_VIEW = PageEvents.KNOWN_PROFILE_PAGE_VIEW, PARENTAL_CONTROLS_SETTINGS_PAGE_VIEW = PageEvents.PARENTAL_CONTROLS_SETTINGS_PAGE_VIEW;
var COLLECTION = PageNames.COLLECTION, COLLECTION_ENTERTAINMENT = PageNames.COLLECTION_ENTERTAINMENT, COLLECTION_HOME = PageNames.COLLECTION_HOME, COLLECTION_LISTEN = PageNames.COLLECTION_LISTEN, COLLECTION_LOCAL = PageNames.COLLECTION_LOCAL, COLLECTION_MOVIES = PageNames.COLLECTION_MOVIES, COLLECTION_NEWS = PageNames.COLLECTION_NEWS, COLLECTION_PERSONALITIES = PageNames.COLLECTION_PERSONALITIES, COLLECTION_PRIMETIME = PageNames.COLLECTION_PRIMETIME, COLLECTION_SHOWS = PageNames.COLLECTION_SHOWS, COLLECTION_SPORTS = PageNames.COLLECTION_SPORTS, CONTINUOUS_PLAY = PageNames.CONTINUOUS_PLAY, DEEPLINK = PageNames.DEEPLINK, ENDCARD = PageNames.ENDCARD, FIND = PageNames.FIND, HOME = PageNames.HOME, LIVE = PageNames.LIVE, MOVIE_DETAIL = PageNames.MOVIE_DETAIL, SEARCH = PageNames.SEARCH, SERIES_DETAIL = PageNames.SERIES_DETAIL, VOD_SECTION = PageNames.VOD_SECTION;
var AUTHENTICATION_STARTED = TrackEvents.AUTHENTICATION_STARTED, FB_LINKING_COMPLETED = TrackEvents.FB_LINKING_COMPLETED, FB_LINKING_STARTED = TrackEvents.FB_LINKING_STARTED, FB_PASSWORD_CREATION_COMPLETED = TrackEvents.FB_PASSWORD_CREATION_COMPLETED, FB_PASSWORD_CREATION_STARTED = TrackEvents.FB_PASSWORD_CREATION_STARTED, FB_SIGN_IN_COMPLETED = TrackEvents.FB_SIGN_IN_COMPLETED, FB_SIGN_IN_STARTED = TrackEvents.FB_SIGN_IN_STARTED, FB_SIGN_UP_COMPLETED = TrackEvents.FB_SIGN_UP_COMPLETED, FB_SIGN_UP_STARTED = TrackEvents.FB_SIGN_UP_STARTED, ONBOARDING_START = TrackEvents.ONBOARDING_START, ON_FAVORITE = TrackEvents.ON_FAVORITE, ON_UNFAVORITE = TrackEvents.ON_UNFAVORITE, PERKS_PRESENTED = TrackEvents.PERKS_PRESENTED, PREVIEW_PASS_EXPIRED = TrackEvents.PREVIEW_PASS_EXPIRED, PREVIEW_PASS_STARTED = TrackEvents.PREVIEW_PASS_STARTED, PROFILE_MARKETING_OPT_IN_CHANGED = TrackEvents.PROFILE_MARKETING_OPT_IN_CHANGED, PROFILE_SCREEN_BACKED_OUT = TrackEvents.PROFILE_SCREEN_BACKED_OUT, PROFILE_UPSELL_PRESENTED = TrackEvents.PROFILE_UPSELL_PRESENTED, SIGN_IN_COMPLETED = TrackEvents.SIGN_IN_COMPLETED, SIGN_IN_ERROR = TrackEvents.SIGN_IN_ERROR, SIGN_IN_FORGOT_PASSWORD_STARTED = TrackEvents.SIGN_IN_FORGOT_PASSWORD_STARTED, SIGN_IN_INCOMPLETE = TrackEvents.SIGN_IN_INCOMPLETE, SIGN_IN_STARTED = TrackEvents.SIGN_IN_STARTED, SIGN_OUT_COMPLETED = TrackEvents.SIGN_OUT_COMPLETED, SIGN_OUT_STARTED = TrackEvents.SIGN_OUT_STARTED, SIGN_UP_COMPLETED = TrackEvents.SIGN_UP_COMPLETED, SIGN_UP_ERROR = TrackEvents.SIGN_UP_ERROR, SIGN_UP_INCOMPLETE = TrackEvents.SIGN_UP_INCOMPLETE, SIGN_UP_STARTED = TrackEvents.SIGN_UP_STARTED;
export var BUSINESS_UNIT = (_c = (_b = (_a = window.ExternalConfig) === null || _a === void 0 ? void 0 : _a.brand) === null || _b === void 0 ? void 0 : _b.businessUnit) !== null && _c !== void 0 ? _c : "fox";
export var BUILD_VERSION_UNIT = ((_d = window.DataLayer) === null || _d === void 0 ? void 0 : _d.isNation())
    ? "foxnation"
    : BUSINESS_UNIT;
export var BUILD_VERSION = BUILD_VERSION_UNIT + " delta web|v" + Version + " (" + BuildNumber + ")";
export var homeTabPageNames = {
    entertainment: COLLECTION_ENTERTAINMENT,
    featured: COLLECTION_HOME,
    home: COLLECTION_HOME,
    listen: COLLECTION_LISTEN,
    local: COLLECTION_LOCAL,
    movies: COLLECTION_MOVIES,
    news: COLLECTION_NEWS,
    personalities: COLLECTION_PERSONALITIES,
    primetime: COLLECTION_PRIMETIME,
    shows: COLLECTION_SHOWS,
    sports: COLLECTION_SPORTS,
};
/**
 * ### noop
 * local implementation of lodash's _.noop
 */
export function noop() { }
/**
 * ### callDelightedSurvey
 * calls the survey() function on the window.delighted.survey object
 * @param anonymousId - Segment anonymous ID needed for the payload passed to survey()
 */
export function callDelightedSurvey(anonymousId) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (anonymousId === void 0) { anonymousId = ""; }
    (_a = window.delighted) === null || _a === void 0 ? void 0 : _a.survey({
        anonymousId: anonymousId,
        app_name: (_d = (_c = (_b = window.ExternalConfig) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.app_name) !== null && _d !== void 0 ? _d : null,
        app_platform: (_g = (_f = (_e = window.ExternalConfig) === null || _e === void 0 ? void 0 : _e.analytics) === null || _f === void 0 ? void 0 : _f.app_platform) !== null && _g !== void 0 ? _g : null,
        app_version: APP_VERSION,
    });
}
/**
 * ### checkRecommendationIdOnClick
 * calls setRecommendationId with the nextRecIdData if the next video has a different
 * recommendation id and is not empty (ex: '')
 * @param currentRecIdData
 * @param nextRecIdData
 * @param setRecommendationId
 */
export function checkRecommendationIdOnClick(currentRecIdData, nextRecIdData, setRecommendationId) {
    var _a, _b;
    if (!setRecommendationId)
        return null;
    var currentRecId = (_a = currentRecIdData === null || currentRecIdData === void 0 ? void 0 : currentRecIdData.recommendationId) !== null && _a !== void 0 ? _a : null;
    var nextRecId = (_b = nextRecIdData === null || nextRecIdData === void 0 ? void 0 : nextRecIdData.recommendationId) !== null && _b !== void 0 ? _b : null;
    // If the next video has a different recommendation id and is not empty (ex: "")
    // Set the state of recomId to the new video
    if (currentRecId !== nextRecId && !!nextRecId) {
        setRecommendationId(nextRecIdData);
    }
    return null;
}
/**
 * ### cleanObject
 * recursively removes most falsy values from an object except 0 and false. This meets the
 * requirements for certain analytics platforms like Segment.
 * @param obj - the object to be cleaned
 */
export var cleanObject = function (obj) {
    if (obj === void 0) { obj = {}; }
    return Object.entries(obj).reduce(function (newObj, _a) {
        var _b, _c;
        var _d;
        var _e = __read(_a, 2), key = _e[0], _f = _e[1], value = _f === void 0 ? null : _f;
        if (typeof value !== "string" &&
            !Array.isArray(value) &&
            Object.keys((_d = value) !== null && _d !== void 0 ? _d : {}).length) {
            return __assign(__assign({}, newObj), (_b = {}, _b[key] = cleanObject(value), _b));
        }
        if ([0, false].includes(value) || value) {
            return __assign(__assign({}, newObj), (_c = {}, _c[key] = value, _c));
        }
        return newObj;
    }, {});
};
var _e = __read(createFunctionContext({
    href: "",
    documentTitle: "",
    search: "",
    pathName: "",
}), 3), usePersistDataProvider = _e[0], usePersistDataSelector = _e[1], usePersistDataClear = _e[2];
export { usePersistDataSelector, usePersistDataProvider, usePersistDataClear };
/**
 * ### defer
 * wraps the given function with requestIdleCallback. This delays the function from being called
 * until the browser is idle.
 * @param cb - the function to be deferred
 */
export function defer(cb) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // in case defer is used inside defer
        var persistedData = usePersistDataSelector();
        var dataToPersist = {
            href: (persistedData === null || persistedData === void 0 ? void 0 : persistedData.href) || window.location.href,
            documentTitle: (persistedData === null || persistedData === void 0 ? void 0 : persistedData.documentTitle) || document.title,
            search: (persistedData === null || persistedData === void 0 ? void 0 : persistedData.search) || window.location.search,
            pathName: (persistedData === null || persistedData === void 0 ? void 0 : persistedData.pathName) || window.location.pathname,
        };
        var _callback = function () {
            usePersistDataProvider(dataToPersist);
            var response = cb.apply(null, args);
            usePersistDataClear();
            return response;
        };
        if (typeof window.requestIdleCallback === "function")
            window.requestIdleCallback(_callback);
        else
            _callback();
    };
}
/**
 * ### executeEvent
 * wrapper function to fire a variety of generic functions in one go. This should eventually be
 * deprecated in favor of using handleAnalytics.
 *
 * TODO: deprecate in favor of using handleAnalytics()
 *
 * @param payload - object containing the event (event name), eventObj which is an object of
 * events which should contain the given event name as a key, and params which as an object of
 * parameters to be passed in to the event payload.
 */
export function executeEvent(_a) {
    var eventObj = _a.eventObj, event = _a.event, params = _a.params;
    if (eventObj === null || eventObj === void 0 ? void 0 : eventObj[event])
        eventObj[event](params);
}
/**
 * ### fireFacebookPixel
 * calls the appropriate Facebook Pixel analytics methods based on the length format of the given
 * video. This function should be called at the beginning of playback.
 * @param lengthFormat - the format length of the video.
 */
export var fireFacebookPixel = function (lengthFormat) {
    var _a;
    var privacyCookie = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getCookie({
        name: "us_privacy",
    });
    if ((privacyCookie === null || privacyCookie === void 0 ? void 0 : privacyCookie.charAt(2)) === "y")
        window.fbq("dataProcessingOptions", ["LDU"]);
    window.fbq("trackSingleCustom", "516838862425328", "All Video Starts");
    window.fbq("trackSingleCustom", "516838862425328", lengthFormat === "long-form"
        ? "Long-Form Video Starts"
        : "Short-Form Starts");
};
/**
 * ### formatPathString
 * takes in a string containing bracket notation (ex: foo['bar']) to use dot notation
 * (ex: foo.bar). This is useful for functions that need to set or get a deeply nested property.
 * @param str - the string to be converted.
 */
export var formatPathString = function (str) {
    return str
        .replace(/\[(\w+)\]/g, ".$1") // convert indices to properties
        .replace(/^\./, "");
}; // strip a leading dot
/**
 * ### getObjectPropertyByStringPath
 * safely returns the value of a property at a deeply-nested address. If the value doesn't exist,
 * undefined is returned.
 * @param obj - the object that contains the deeply nested property.
 * @param str - the path where the property is located within the object.
 */
export var getObjectPropertyByStringPath = function (obj, str) {
    var addresses = str.split(".");
    var node = obj;
    for (var i = 0, n = addresses.length; i < n; ++i) {
        var address = addresses[i];
        if (typeof node === "object" && node.hasOwnProperty(address))
            node = node[address];
        else
            return undefined;
    }
    return node;
};
/**
 * ### setPropertyAtStringPath
 * set the value of a property at a given property path.
 * @param obj - the object on which the path will be set.
 * @param pathString - the path where the value will be set.
 * @param value - the value that the path will be set to.
 */
export var setPropertyAtStringPath = function (obj, pathString, value) {
    var path = pathString.split(".");
    var i;
    for (i = 0; i < path.length - 1; i++)
        obj = obj[path[i]];
    obj[path[i]] = value;
};
/**
 * ### deeplySetProperty
 * local implementation of lodash's _.set method. Safely sets a property on a given object at a
 * given path with a given value. If the property path doesn't exist, it's created on the object.
 * @param obj - the object where the property will be set.
 * @param pathString - the path where the property is located.
 * @param value - the value that the property will be set to.
 */
export function deeplySetProperty(obj, pathString, value) {
    var e_1, _a;
    var addresses = formatPathString(pathString).split(".");
    var concatenatedAddress = "";
    try {
        for (var _b = __values(addresses.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), index = _d[0], address = _d[1];
            var isLastAddress = index === addresses.length - 1;
            var collectionType = typeof address === "number" ? [] : {};
            concatenatedAddress += concatenatedAddress.length ? "." + address : address;
            if (isLastAddress ||
                !getObjectPropertyByStringPath(obj, concatenatedAddress)) {
                setPropertyAtStringPath(obj, concatenatedAddress, isLastAddress ? value : collectionType);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
// TODO: remove once Tealium/Adobe analytics disabled
export var getAccountAnalyticsEvents = function (_a) {
    var _b;
    var _c = _a.foxProfileState, foxProfileState = _c === void 0 ? noop : _c, profileId = _a.profileId;
    var tealiumEvents = getTealiumAccountEvents({ profileId: profileId });
    return _b = {},
        _b[AUTHENTICATION_STARTED] = function () {
            var _a;
            var params = Object.entries((_a = window.utag_data) !== null && _a !== void 0 ? _a : {}).reduce(function (newObj, _a) {
                var _b;
                var _c = __read(_a, 2), key = _c[0], value = _c[1];
                return [
                    "page_activation_code",
                    "page_profile_activation_method",
                    "page_start_source",
                ].includes(key)
                    ? __assign(__assign({}, newObj), (_b = {}, _b[key] = value, _b)) : newObj;
            }, {});
            executeEvent({
                eventObj: tealiumEvents,
                params: params,
                event: AUTHENTICATION_STARTED,
            });
        },
        _b[ONBOARDING_START] = function (_a) {
            var utagAccountSource = _a.utagAccountSource;
            return executeEvent({
                eventObj: tealiumEvents,
                params: { utagAccountSource: utagAccountSource },
                event: ONBOARDING_START,
            });
        },
        _b[ON_FAVORITE] = function (_a) {
            var seriesId = _a.seriesId, location = _a.location;
            return executeEvent({
                eventObj: tealiumEvents,
                event: ON_FAVORITE,
                params: { seriesId: seriesId, location: location },
            });
        },
        _b[ON_UNFAVORITE] = function (_a) {
            var seriesId = _a.seriesId, location = _a.location;
            return executeEvent({
                eventObj: tealiumEvents,
                event: ON_UNFAVORITE,
                params: { seriesId: seriesId, location: location },
            });
        },
        _b[PERKS_PRESENTED] = function (_a) {
            var utagAccountSource = _a.utagAccountSource;
            return executeEvent({
                eventObj: tealiumEvents,
                event: PERKS_PRESENTED,
                params: { utagAccountSource: utagAccountSource },
            });
        },
        _b[SIGN_IN_COMPLETED] = function (_a) {
            var utagAccountSource = _a.utagAccountSource;
            executeEvent({
                eventObj: tealiumEvents,
                params: { utagAccountSource: utagAccountSource },
                event: SIGN_IN_COMPLETED,
            });
            foxProfileState(FP_SIGN_IN_COMPLETED);
        },
        _b[SIGN_IN_ERROR] = function (_a) {
            var utagAccountSource = _a.utagAccountSource;
            return executeEvent({
                eventObj: tealiumEvents,
                event: SIGN_IN_ERROR,
                params: { utagAccountSource: utagAccountSource },
            });
        },
        _b[SIGN_IN_FORGOT_PASSWORD_STARTED] = function (_a) {
            var utagAccountSource = _a.utagAccountSource;
            return executeEvent({
                eventObj: tealiumEvents,
                event: SIGN_IN_FORGOT_PASSWORD_STARTED,
                params: { utagAccountSource: utagAccountSource },
            });
        },
        _b[SIGN_IN_INCOMPLETE] = function (_a) {
            var utagAccountSource = _a.utagAccountSource;
            return executeEvent({
                eventObj: tealiumEvents,
                event: SIGN_IN_INCOMPLETE,
                params: { utagAccountSource: utagAccountSource },
            });
        },
        _b[SIGN_IN_STARTED] = function (_a) {
            var utagAccountSource = _a.utagAccountSource, onboardingAction = _a.onboardingAction;
            var event = SIGN_IN_STARTED;
            executeEvent({
                eventObj: tealiumEvents,
                params: { utagAccountSource: utagAccountSource, onboardingAction: onboardingAction },
                event: event,
            });
            foxProfileState(FP_SIGN_IN_ATTEMPTED);
        },
        _b[SIGN_OUT_COMPLETED] = function (_a) {
            var cb = _a.cb;
            var event = SIGN_OUT_COMPLETED;
            executeEvent({ eventObj: tealiumEvents, event: event });
            foxProfileState(FP_SIGNED_OUT);
        },
        _b[SIGN_OUT_STARTED] = function () {
            var event = SIGN_OUT_STARTED;
            executeEvent({ eventObj: tealiumEvents, event: event });
            foxProfileState(FP_SIGN_OUT_ATTEMPTED);
        },
        _b[SIGN_UP_COMPLETED] = function (_a) {
            var newsLetter = _a.newsLetter, utagAccountSource = _a.utagAccountSource;
            executeEvent({
                eventObj: tealiumEvents,
                event: SIGN_UP_COMPLETED,
                params: { newsLetter: newsLetter, utagAccountSource: utagAccountSource },
            });
            foxProfileState(FP_SIGN_UP_COMPLETED);
        },
        _b[SIGN_UP_ERROR] = function (_a) {
            var utagAccountSource = _a.utagAccountSource;
            return executeEvent({
                eventObj: tealiumEvents,
                event: SIGN_UP_ERROR,
                params: { utagAccountSource: utagAccountSource },
            });
        },
        _b[SIGN_UP_INCOMPLETE] = function (_a) {
            var utagAccountSource = _a.utagAccountSource;
            return executeEvent({
                eventObj: tealiumEvents,
                event: SIGN_UP_INCOMPLETE,
                params: { utagAccountSource: utagAccountSource },
            });
        },
        _b[SIGN_UP_STARTED] = function (_a) {
            var utagAccountSource = _a.utagAccountSource, onboardingAction = _a.onboardingAction;
            var event = SIGN_UP_STARTED;
            executeEvent({
                eventObj: tealiumEvents,
                params: { utagAccountSource: utagAccountSource, onboardingAction: onboardingAction },
                event: event,
            });
            foxProfileState(FP_SIGN_UP_ATTEMPTED);
        },
        _b;
};
/**
 * ### recursiveMerge
 * takes in any number of objects as arguments and recursively merges them, similar to lodash's
 * _.merge
 * @param objects - any number of objects
 */
export function recursiveMerge() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    function coerceToNumber(key) {
        return isNaN(+key) ? key : +key;
    }
    function byMerger(newObj, obj) {
        if (obj === void 0) { obj = {}; }
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var value = obj[key];
                var typeSafeKey = coerceToNumber(key);
                if (newObj[typeSafeKey] !== null || newObj[typeSafeKey] !== undefined) {
                    if (typeof newObj[typeSafeKey] === "object" &&
                        typeof value === "object" &&
                        Object.keys(newObj[typeSafeKey]).length) {
                        newObj[typeSafeKey] = byMerger(Array.isArray(newObj[typeSafeKey])
                            ? __spreadArray([], __read(newObj[typeSafeKey])) : __assign({}, newObj[typeSafeKey]), Array.isArray(value) ? __spreadArray([], __read(value)) : __assign({}, value));
                    }
                    else {
                        newObj[typeSafeKey] = value;
                    }
                }
                else {
                    newObj[typeSafeKey] = value;
                }
            }
        }
        return newObj;
    }
    /**
     * It should have returned Object rather than AnyObject.
     */
    return objects.reduce(byMerger, {});
}
// TODO: possibly refactor so that this only gets used during second screen activation flow
export var getActivationProps = function () {
    var _a, _b, _c;
    var pageActivationCode = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getQueryParameter("code");
    var anonymousId = pageActivationCode
        ? window.DataLayer.getCookie({ name: SECOND_SCREEN_ANONYMOUS_ID })
        : "";
    var activationProps = cleanObject({
        page_profile_activation_method: pageActivationCode && "2nd screen",
        page_activation_code: pageActivationCode,
        page_start_source: getSegmentPageStartSource(),
    });
    if (pageActivationCode && !((_b = window.utag_data) === null || _b === void 0 ? void 0 : _b.page_activation_code))
        deeplySetProperty(window, "utag_data", recursiveMerge((_c = window.utag_data) !== null && _c !== void 0 ? _c : {}, {
            page_profile_activation_method: "no activation method",
            page_activation_code: "no activation code",
            page_start_source: "no start source",
        }, activationProps, { last_anonymous_profile_id: anonymousId }));
    return activationProps;
};
/**
 * ### getAdjacentCollectionAbove
 * gets the heading of the collection above the currently activated collection.
 * @param panels - all collections
 * @param index - vertical index (starting from 1) of the currently activated collection
 */
export var getAdjacentCollectionAbove = function (panels, index) { var _a, _b, _c; return (_c = (_b = (_a = panels.member) === null || _a === void 0 ? void 0 : _a[index - 1]) === null || _b === void 0 ? void 0 : _b.headline) !== null && _c !== void 0 ? _c : ""; };
/**
 * ### getCollectionCount
 * return a number representing the total collections on the screen that the user will be able to
 * see.
 * @param panels - all collections
 * @param hiddenPanels - array of panel IDs that were programmatically hidden in the frontend.
 */
export var getCollectionCount = function (panels, hiddenPanels) {
    if (panels === void 0) { panels = {}; }
    if (hiddenPanels === void 0) { hiddenPanels = []; }
    return getVisibleCollections(panels, hiddenPanels).length;
};
/**
 * ### getCollectionPosition
 * determines the index of a collection based on its headline
 * @param panels - all collections
 * @param index - the map index of the collection. This may or may not be the index we need since
 * there may be hidden collections that we need to take into account.
 * @param headline - the headline of the collection for which we need to find the index.
 * @param hiddenPanels - an array of panel Ids that were programmatically hidden in the frontend.
 */
export var getCollectionPosition = function (panels, index, headline, hiddenPanels) {
    if (panels === void 0) { panels = {}; }
    if (index === void 0) { index = 0; }
    if (headline === void 0) { headline = ""; }
    if (hiddenPanels === void 0) { hiddenPanels = []; }
    var collections = getVisibleCollections(panels, hiddenPanels);
    return collections.length
        ? collections.findIndex(function (panel) { return panel.headline === headline; }) + 1
        : index + 1;
};
/**
 * ### getFavoritesListString
 * returns a concatenated string of all favorites added by the user.
 * @param favorites - an array of favorites object data.
 */
export var getFavoritesListString = function (favorites) {
    if (favorites === void 0) { favorites = []; }
    if (favorites.length) {
        return favorites.reduce(function (str, favorite, idx) {
            var _a = favorite.id, id = _a === void 0 ? "" : _a, _b = favorite.type, type = _b === void 0 ? "" : _b;
            return "" + str + (idx > 0 ? "," : "") + (type ? type.toLowerCase() + ":" : "") + id.split("-").join(" ");
        }, "");
    }
    return "";
};
/**
 * ### getFavoritesProps
 * returns an array with two items: favorites props (index 0), and personalities props (index 1)
 * @param favorites - array of favorites objects
 */
export var getFavoritesProps = function (favorites) {
    var _a;
    if (favorites === void 0) { favorites = []; }
    function byPartition(favorites, favorite) {
        var _a = __read(favorites, 2), favs = _a[0], personalities = _a[1];
        var type = favorite.type;
        if (type === FAVORITES_TYPE_PERSONALITY)
            return [
                favs,
                __spreadArray(__spreadArray([], __read(personalities)), [{ id: favorite.id, type: "personality" }]),
            ];
        return [__spreadArray(__spreadArray([], __read(favs)), [favorite]), personalities];
    }
    var _b = __read((_a = favorites === null || favorites === void 0 ? void 0 : favorites.reduce(byPartition, [[], []])) !== null && _a !== void 0 ? _a : [
        [],
        [],
    ], 2), favs = _b[0], personalities = _b[1];
    return cleanObject({
        favorites_personalities_list: getFavoritesListString(personalities),
        favorites_personalities_length: personalities.length,
        favorites_content_list: getFavoritesListString(favs),
        favorites_content_length: favs.length,
    });
};
export function getPageLoginState(account) {
    var _a;
    return (account !== null && account !== void 0 ? account : (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getAccount()) ? LOGGED_IN : LOGGED_OUT;
}
export var getPreviewPassAnalyticsEvents = function (_a) {
    var _b;
    var profileId = _a.profileId, previewPassLength = _a.previewPassLength;
    var tealiumEvents = getTealiumPreviewPassEvents({ profileId: profileId });
    return _b = {},
        _b[PREVIEW_PASS_EXPIRED] = function () {
            var props = {
                method: "preview pass expiration",
                video_player_state: SegmentPlayerStates.PAUSE,
            };
            callSegmentPlayerEvent({
                eventName: SegmentVideoEventStrings.videoPlaybackInterrupted,
                props: props,
            });
            executeEvent({
                eventObj: tealiumEvents,
                event: PREVIEW_PASS_EXPIRED,
                params: { previewPassLength: previewPassLength },
            });
        },
        _b[PREVIEW_PASS_STARTED] = function () {
            executeEvent({
                eventObj: tealiumEvents,
                event: PREVIEW_PASS_STARTED,
                params: { previewPassLength: previewPassLength },
            });
        },
        _b;
};
export var getRecommendationId = function (recIdData) { var _a; return (_a = recIdData === null || recIdData === void 0 ? void 0 : recIdData.recommendationId) !== null && _a !== void 0 ? _a : null; };
export var getRecommendationIdDataForItem = function (videoObject, index) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (index === void 0) { index = null; }
    if (index !== null) {
        return {
            showCode: (_c = (_b = (_a = videoObject.member) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.showCode) !== null && _c !== void 0 ? _c : null,
            recommendationId: (_h = (_g = (_f = (_e = (_d = videoObject.member) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.trackingData) === null || _f === void 0 ? void 0 : _f.properties) === null || _g === void 0 ? void 0 : _g.recommendationId) !== null && _h !== void 0 ? _h : null,
        };
    }
    return {
        showCode: (_j = videoObject.showCode) !== null && _j !== void 0 ? _j : null,
        recommendationId: (_m = (_l = (_k = videoObject.trackingData) === null || _k === void 0 ? void 0 : _k.properties) === null || _l === void 0 ? void 0 : _l.recommendationId) !== null && _m !== void 0 ? _m : null,
    };
};
export var getTimePartingInfo = function () {
    var date = new Date();
    var days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
    ];
    var hour = date.getUTCHours();
    var minute = date.getUTCMinutes();
    return {
        page_timePartingDay: days[date.getUTCDay()],
        page_timePartingHour: hour + (minute >= 30 ? ":30" : ":00"),
    };
};
export var getVisibleCollections = function (panels, hiddenPanels) {
    if (panels === void 0) { panels = {}; }
    if (hiddenPanels === void 0) { hiddenPanels = []; }
    var panelTypes = [
        "categorylist",
        "content",
        "playerBanner",
        "shows",
        "videos",
        "trending",
    ];
    var hiddenPanelsArr = Array.from(hiddenPanels);
    if (!panels.member)
        return [];
    return panels.member.filter(function (item) {
        if (!Object.keys(item !== null && item !== void 0 ? item : {}).length)
            return false;
        var _a = item.id, id = _a === void 0 ? "" : _a, _b = item.collectionCTA, collectionCTA = _b === void 0 ? "" : _b, _c = item.collectionType, collectionType = _c === void 0 ? "" : _c, _d = item.panelType, panelType = _d === void 0 ? "" : _d;
        return ((hiddenPanelsArr.indexOf(id) === -1 &&
            panelTypes.indexOf(panelType) !== -1) ||
            collectionCTA ||
            collectionType === "genre");
    });
};
// TODO: move to OptimizelyHelper if it gets ported to delta-web-analytics
function handleOptimizelyAnalytics(_a) {
    var _b;
    var event = _a.event, payload = _a.payload;
    var Optimizely = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.getOptimizely();
    if (Optimizely)
        Optimizely.push({
            type: "event",
            eventName: event,
            tags: payload,
        });
}
/**
 * ### handleVendorAnalytics
 * handles any analytics-related event emissions for the given vendor. This function is called
 * internally within handleAnalytics.
 * @param callback - mainly used by segment to execute code after the event is processed.
 * @param event - string name of the event.
 * @param payload - object of properties for the event.
 * @param tealiumPayload - object of properties for the Tealium event.
 * @param vendor - string name of the analytics vendor the event belongs to.
 */
function handleVendorAnalytics(_a) {
    var _b = _a.callback, callback = _b === void 0 ? noop : _b, event = _a.event, payload = _a.payload, tealiumPayload = _a.tealiumPayload, vendor = _a.vendor;
    switch (vendor) {
        case Vendors.OPTIMIZELY: {
            handleOptimizelyAnalytics({ event: event, payload: payload });
            break;
        }
        case Vendors.SEGMENT: {
            handleSegmentAnalytics({ callback: callback, event: event, payload: payload });
            break;
        }
        case Vendors.TEALIUM: {
            handleTealiumAnalytics({
                event: event,
                payload: tealiumPayload || payload || {},
            });
            break;
        }
        default:
            break;
    }
}
/**
 * ### handleAnalytics
 * handles any analytics-related event emissions.
 * @param events - a comma-separated list of AnalyticsEvent objects { callback, event, payload }.
 */
export var handleAnalytics = function () {
    var e_2, _a;
    var events = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        events[_i] = arguments[_i];
    }
    var _loop_1 = function (callback, event_1, payload, tealiumPayload) {
        EventVendorMap[event_1].forEach(function (vendor) {
            return handleVendorAnalytics({
                callback: callback,
                event: event_1,
                payload: payload,
                tealiumPayload: tealiumPayload,
                vendor: vendor,
            });
        });
    };
    try {
        for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
            var _b = events_1_1.value, callback = _b.callback, event_1 = _b.event, payload = _b.payload, tealiumPayload = _b.tealiumPayload;
            _loop_1(callback, event_1, payload, tealiumPayload);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
export var hasEntitlementOverride = function () {
    var _a, _b, _c, _d, _e;
    var entitlementCookieName = (_b = (_a = window.ExternalConfig) === null || _a === void 0 ? void 0 : _a.entitlementCookieName) !== null && _b !== void 0 ? _b : "";
    var entitlementCookie = (_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.getCookie({
        name: entitlementCookieName,
    });
    if (entitlementCookie) {
        var isNation = ((_e = (_d = window.ExternalConfig) === null || _d === void 0 ? void 0 : _d.analytics) === null || _e === void 0 ? void 0 : _e.app_name) === NATION;
        if (isNation)
            return "foxnation";
    }
    return false;
};
export var isCollection = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === COLLECTION; };
export var isContinuousPlay = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === CONTINUOUS_PLAY; };
export var isDeeplink = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === DEEPLINK; };
export var isEndcard = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === ENDCARD; };
export var isFind = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === FIND; };
export var isHome = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === HOME; };
export var isLive = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === LIVE; };
export var isMovieDetail = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === MOVIE_DETAIL; };
export var isSearch = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === SEARCH; };
export var isSeriesDetail = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === SERIES_DETAIL; };
export var isVodSection = function (data, index) { var _a; return ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.name) === VOD_SECTION; };
export var mountSessionCam = function () {
    if (!document.getElementById("sessioncam")) {
        var code = "\n      <!-- SessionCam Client Integration v6.0 -->\n      //<![CDATA[\n      var scRec=document.createElement('SCRIPT');\n      scRec.type='text/javascript';\n      scRec.src=\"//d2oh4tlt9mrke9.cloudfront.net/Record/js/sessioncam.recorder.js\"\n      document.getElementsByTagName('head')[0].appendChild(scRec);\n      //]]>\n      <!-- End SessionCam -->\n    ";
        var script = document.createElement("script");
        script.id = "sessioncam";
        script.setAttribute("type", "text/javascript");
        script.appendChild(document.createTextNode(code));
        document.body.appendChild(script);
    }
};
export function omitProperties(obj, props) {
    function byOmission(acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (props.includes(key))
            return acc;
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }
    return Object.entries(obj).reduce(byOmission, {});
}
export function pushProfileIdsToGoogleDataLayer() {
    var _a, _b, _c;
    // TODO: maybe rename delta-web-analytics DataLayer to avoid confusion with google's dataLayer
    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
        dcg_profile_id: (_c = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.getAccount()) === null || _c === void 0 ? void 0 : _c.profileId,
        lastAnonymousProfileId: getLastAnonymousProfileId(),
        lastKnownProfileId: getLastKnownProfileId(),
    });
}
export var resetPageReferrerData = function () { return setPageReferrerToStorage([]); };
export var setPageReferrerToStorage = function (data) {
    var _a;
    return (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.setSessionStorage({
        key: SESSION_STORAGE_REFERRER_TRACKING,
        value: JSON.stringify(data),
    });
};
export var setPageReferrerData = function (_a) {
    var _b;
    var name = _a.name, data = _a.data;
    var sessionStorage = (_b = window.sessionStorage) === null || _b === void 0 ? void 0 : _b.length;
    if (sessionStorage) {
        var newValue = {
            name: name,
            data: data,
        };
        var values = getPageReferrerDataFromStorage();
        values.unshift(newValue);
        values.length = MAX_REFERRER_LENGTH;
        setPageReferrerToStorage(values);
    }
};
/* only for React class components */
export function setBlockReferrerAnalyticsTracking(value) {
    this.setState({ blockReferrerAnalyticsTracking: value });
}
export function setDataLayerPageProps() {
    var _a, _b;
    if (((_a = window.utag_data) === null || _a === void 0 ? void 0 : _a.page_name) && window.utag_data.page_type)
        return;
    var storagePageProps = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.getLocalStorage({
        key: PAGE_PROPS_STORAGE,
    });
    if (storagePageProps && window.utag_data) {
        var _c = __read(storagePageProps.split("/"), 2), storagePageName = _c[0], storagePageType = _c[1];
        deeplySetProperty(window, "utag_data.page_name", storagePageName);
        deeplySetProperty(window, "utag_data.page_type", storagePageType);
    }
}
// TODO: look into moving into handleAnalytics
export var setOptimizelyCollectionViewedEvent = function (_a) {
    var anonymousId = _a.anonymousId, featuredTitle = _a.featuredTitle, panelId = _a.panelId, position = _a.position;
    if (!window.DataLayer)
        return;
    // string concat of the collection viewed at the given vertical position on the given url
    var viewId = window.location.href + " " + panelId + " " + position;
    if (!window.DataLayer.collectionsViewed) {
        var sessionStorage_1 = window.DataLayer.getSessionStorage({
            key: OPTIMIZELY_COLLECTION_VIEWED_SESSION_STORAGE,
        });
        window.DataLayer.collectionsViewed = new Set((sessionStorage_1 === null || sessionStorage_1 === void 0 ? void 0 : sessionStorage_1.split("::")) || []);
    }
    if (window.DataLayer.collectionsViewed.has(viewId))
        return;
    window.DataLayer.collectionsViewed.add(viewId);
    window.DataLayer.setSessionStorage({
        key: OPTIMIZELY_COLLECTION_VIEWED_SESSION_STORAGE,
        value: __spreadArray([], __read(window.DataLayer.collectionsViewed)).join("::"),
    });
    var tags = {
        page_collection_title: featuredTitle,
        page_collection_vertical_position: position,
        page_url: window.location.href,
        segment_anonymousId: anonymousId,
    };
    var Optimizely = window.DataLayer.getOptimizely();
    if (Object.keys(Optimizely !== null && Optimizely !== void 0 ? Optimizely : {}).length) {
        Optimizely.push({
            type: "event",
            eventName: OPTIMIZELY_COLLECTION_VIEWED,
            tags: tags,
        });
        Optimizely.push({
            type: "page",
            pageName: "collection_viewed_" + position,
            tags: __assign(__assign({}, tags), { page_title: document.title }),
        });
    }
};
export function setPagePropsStorage() {
    var _a, _b, _c, _d, _e;
    var pageName = (_b = (_a = window.utag_data) === null || _a === void 0 ? void 0 : _a.page_name) !== null && _b !== void 0 ? _b : "";
    var pageType = (_d = (_c = window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type) !== null && _d !== void 0 ? _d : "";
    (_e = window.DataLayer) === null || _e === void 0 ? void 0 : _e.setLocalStorage({
        key: PAGE_PROPS_STORAGE,
        value: pageName || pageType ? pageName + "/" + pageType : "",
    });
}
/* only for React class components */
export function trackPageReferrerAnalytics(_a) {
    var name = _a.name, data = _a.data, cancelSetTrackedAnalyticsReferrer = _a.cancelSetTrackedAnalyticsReferrer, ignoreTrackedAnalyticsReferrer = _a.ignoreTrackedAnalyticsReferrer;
    var trackedAnalyticsReferrer = this.state.trackedAnalyticsReferrer;
    var blockReferrerAnalyticsTracking = this.props.blockReferrerAnalyticsTracking;
    var isTracked = !ignoreTrackedAnalyticsReferrer && trackedAnalyticsReferrer;
    if (name && !isTracked && !blockReferrerAnalyticsTracking) {
        if (!cancelSetTrackedAnalyticsReferrer)
            this.setState({ trackedAnalyticsReferrer: true });
        setPageReferrerData({ name: name, data: data });
    }
}
export function trackPageReferrerAnalyticsHook(_a) {
    var name = _a.name, data = _a.data, trackedAnalyticsReferrer = _a.trackedAnalyticsReferrer, blockReferrerAnalyticsTracking = _a.blockReferrerAnalyticsTracking, setTrackedAnalyticsReferrer = _a.setTrackedAnalyticsReferrer, cancelSetTrackedAnalyticsReferrer = _a.cancelSetTrackedAnalyticsReferrer, ignoreTrackedAnalyticsReferrer = _a.ignoreTrackedAnalyticsReferrer;
    var isTracked = !ignoreTrackedAnalyticsReferrer && trackedAnalyticsReferrer;
    if (setTrackedAnalyticsReferrer) {
        if (name && !isTracked && !blockReferrerAnalyticsTracking) {
            if (!cancelSetTrackedAnalyticsReferrer) {
                setTrackedAnalyticsReferrer(true);
            }
            setPageReferrerData({ name: name, data: data });
        }
    }
}
export var updateNielsenOTTStatus = function (start, castData) {
    var _a, _b;
    if (castData === void 0) { castData = {}; }
    var OTTEnv = (_b = (_a = window.NOLBUNDLE) === null || _a === void 0 ? void 0 : _a[NielsenOTTEnv]) !== null && _b !== void 0 ? _b : null;
    if (!OTTEnv)
        return;
    var data = {};
    if (start) {
        var displayName = castData.displayName, sessionId = castData.sessionId, status_1 = castData.status;
        data = {
            ottStatus: "1",
            ottType: status_1,
            ottDevice: "ottchromecast",
            ottDeviceName: displayName,
            ottDeviceID: sessionId,
            ottDeviceManufacturer: "google",
            ottDeviceModel: "ottChromeCast",
            ottDeviceVersion: "1.0.0",
        };
    }
    else {
        data = { ottStatus: "0" };
    }
    OTTEnv.ggPM("updateOTT", data);
};
